<template>
  <component :is="runSheetComponent" v-if="deliveryRunExists" />
</template>

<script>
import { get, call } from 'vuex-pathify'
import RunSheetDefault from './RunSheetDefault.vue'
import RunSheetConsignment from './RunSheetConsignment.vue'

export default {
  props: ['id'],

  computed: {
    ...get('deliveryRuns', ['deliveryRunExists', 'deliveryRun']),

    runSheetComponent () {
      if (this.deliveryRunExists) {
        if (this.deliveryRun.consignment) {
          return RunSheetConsignment
        }

        return RunSheetDefault
      }

      return null
    }
  },

  async created () {
    await this.getDeliveryRun(this.id)
  },

  methods: {
    ...call('deliveryRuns', ['getDeliveryRun'])
  }
}
</script>
